<script>
import { mapActions, mapGetters } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import FilePreviewContainer from '../../general/file-preview-container.vue'

export default {
  name: 'TimesheetFilePreview',
  components: {
    FilePreviewContainer,
  },
  mixins: [baseMixin],
  props: {
    timesheetData: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data: () => {
    return {
      fileData: '',
      fileDefinition: {},
    }
  },
  computed: {
    ...mapGetters({
      isDownloadingFile: 'timesheets/isLoading',
    }),
  },
  watch: {
    show(n, o) {
      if (n) {
        if (this.timesheetData != null) {
          this.downloadFile()
        }
      } else {
        this.fileData = ''
        this.fileDefinition = {}
      }
    },
  },
  methods: {
    ...mapActions({
      downloadTimesheet: 'timesheets/downloadTimesheet',
    }),
    async downloadFile() {
      const result = await this.downloadTimesheet(
        this.timesheetData.timesheetRecordId
      )

      if (!result.isSuccess) return

      this.fileData = result.data
      this.fileDefinition = {
        fileName: 'timesheet.pdf',
      }
    },
  },
}
</script>

<template>
  <section>
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      persistent
      no-click-animation
      transition="dialog-bottom-transition"
      @input="$emit('update:show')"
    >
      <v-card>
        <v-container>
          <v-card-title
            >{{ $t('finance.timesheetText') }} #{{
              timesheetData === null ? '--' : timesheetData.timesheetRecordId
            }}
            <v-btn class="ml-auto" icon @click="$emit('update:show', false)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <FilePreviewContainer
              :loading="isDownloadingFile"
              :file-data="fileData"
              :file-definition="fileDefinition"
              :empty-state-title="$t('finance.timesheetFileNotAvailableText')"
              class="mt-4"
            />
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
